import React from 'react'
import AnimationLink from '../Link'
import LetsTalkCta from '../LetsTalkCta'
import arrowSmallWhite from '../../assets/images/arrow-small-white.svg'
import { getWorkShowcaseEntries } from '../../constants/workShowcase'

/** Icon inside 40px circle (see `.home-work-showcase__card-arrow img`) */
const CARD_ARROW_PX = 22

const HEADLINE = {
  en: 'Customer-driven since day 1.',
  pt: 'Ao serviço do cliente desde o primeiro dia.',
}

const LEAD = {
  en: "We're always eager to dive into any tech challenge.",
  pt: 'Estamos sempre prontos para mergulhar em qualquer desafio tecnológico.',
}

const OUR_PROJECTS_LABEL = {
  en: 'Our Projects',
  pt: 'Os nossos trabalhos',
}

/** Figma-style tags: two labels only; circle + triangle icons (home section only). */
const HomeShowcaseTags = ({ items }) => {
  const pair = items.slice(0, 2)
  return (
    <ul className="home-work-showcase__tags">
      {pair.map((label, i) => (
        <li key={`${label}-${i}`} className="home-work-showcase__tag">
          <span
            className={
              i === 0
                ? 'home-work-showcase__tag-icon home-work-showcase__tag-icon--circle'
                : 'home-work-showcase__tag-icon home-work-showcase__tag-icon--triangle'
            }
            aria-hidden
          />
          <span className="home-work-showcase__tag-label">{label}</span>
        </li>
      ))}
    </ul>
  )
}

const HomeThree = ({ lang }) => {
  const isEn = lang === 'en'
  const locale = isEn ? 'en' : 'pt'
  const projects = getWorkShowcaseEntries(isEn)
  const workBase = isEn ? '/en/work/' : '/trabalho/'

  return (
    <section id="home-three" className="bg-blue home-work-showcase">
      <div className="content container">

        <div className="row">
          <header className="col-12 home-work-showcase__header">
            <h2 className="home-work-showcase__headline">{HEADLINE[locale]}</h2>
            <div className="home-work-showcase__header-row">
              <p className="home-work-showcase__lead">{LEAD[locale]}</p>
              <div className="home-work-showcase__header-ctas">
                <LetsTalkCta
                  isEn={isEn}
                  hex="#322EFF"
                  tone="onDark"
                  to={workBase}
                  label={OUR_PROJECTS_LABEL[locale]}
                />
                <LetsTalkCta isEn={isEn} hex="#322EFF" tone="onDark" />
              </div>
            </div>
          </header>
        </div>

        <div className="home-work-showcase__grid">
          {projects.map(project => (
            <AnimationLink
              key={project.id}
              className="home-work-showcase__card"
              hex="#322EFF"
              paintDrip
              to={`${workBase}#${project.id}`}
              id={`#${project.id}`}
            >
              <span className="home-work-showcase__card-hover-frame" aria-hidden="true" />
              <div className="home-work-showcase__card-inner">
                <div className="home-work-showcase__card-media">
                  <img
                    src={project.image}
                    alt=""
                    loading={project.loading || 'lazy'}
                    decoding="async"
                    className="home-work-showcase__card-img"
                  />
                </div>
                <div className="home-work-showcase__card-panel">
                  <div className="home-work-showcase__card-heading">
                    <h3 className="home-work-showcase__card-title">{project.title}</h3>
                    <span className="home-work-showcase__card-arrow" aria-hidden="true">
                      <img
                        src={arrowSmallWhite}
                        alt=""
                        width={CARD_ARROW_PX}
                        height={CARD_ARROW_PX}
                        decoding="async"
                      />
                    </span>
                  </div>
                  <div className="home-work-showcase__card-rule" aria-hidden="true" />
                  <p className="home-work-showcase__card-desc">{project.description}</p>
                  <HomeShowcaseTags items={project.workTypes.items} />
                </div>
              </div>
            </AnimationLink>
          ))}
        </div>
      </div>
    </section>
  )
}
export default HomeThree
